import React from 'react';

const INK    = '#2B2620';
const WALNUT = '#8B4513';
const MOSS   = '#3B6B44';
const OCHRE  = '#A6752A';
const RUST   = '#A13D2D';
const STONE  = '#8C8275';
const PAPER  = '#FDFBF8';
const FONT_DISPLAY = "'Fraunces', Georgia, serif";
const FONT_SANS    = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

const statusColors = {
  sold: OCHRE,
  awaiting_production: STONE,
  in_production: OCHRE,
  ready_for_install: MOSS,
  ready_for_pickup: MOSS,
  scheduled: WALNUT,
  completed: MOSS,
  cancelled: RUST,
};

export default function StatusDistributionChart({ data = [] }) {
  const maxCount = Math.max(...data.map(d => d.count), 1);

  return (
    <div style={{
      padding: '20px',
      background: PAPER,
      borderRadius: '14px',
      border: '1px solid rgba(139,69,19,0.1)',
      boxShadow: '0 2px 12px rgba(139,69,19,0.06)',
      fontFamily: FONT_SANS,
    }}>
      <h3 style={{
        fontSize: '15px',
        fontWeight: '600',
        color: INK,
        marginBottom: '20px'
      }}>
        Status Distribution
      </h3>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }}>
        {data.map((item, index) => {
          const percentage = maxCount > 0 ? (item.count / maxCount) * 100 : 0;
          const color = statusColors[item.status.toLowerCase()] || STONE;

          return (
            <div key={index}>
              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '6px'
              }}>
                <span style={{
                  display: 'flex', alignItems: 'center', gap: '6px',
                  fontSize: '13px',
                  fontWeight: '600',
                  color: INK,
                  textTransform: 'capitalize'
                }}>
                  <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: color, flexShrink: 0 }} />
                  {item.label || item.status.replace(/_/g, ' ')}
                </span>
                <span style={{
                  fontFamily: FONT_DISPLAY,
                  fontSize: '15px',
                  fontWeight: 600,
                  color
                }}>
                  {item.count}
                </span>
              </div>

              {/* Bar */}
              <div style={{
                width: '100%',
                height: '22px',
                background: 'rgba(139,69,19,0.06)',
                borderRadius: '8px',
                overflow: 'hidden',
                position: 'relative'
              }}>
                <div style={{
                  width: `${percentage}%`,
                  height: '100%',
                  background: color,
                  borderRadius: '8px',
                  transition: 'width 0.5s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  paddingRight: '8px'
                }}>
                  {percentage > 15 && (
                    <span style={{
                      fontSize: '11px',
                      fontWeight: '700',
                      color: 'white'
                    }}>
                      {Math.round(percentage)}%
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {data.length === 0 && (
        <div style={{
          padding: '40px 20px',
          textAlign: 'center',
          color: STONE,
          fontSize: '13px'
        }}>
          No data available
        </div>
      )}
    </div>
  );
}
